export default __webpack_public_path__ + "static/media/air-conditioner.cced1168.svg";